import React, {Component, Fragment} from 'react';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';

import {SiteFooter} from '@homeaway/react-site-footer';
import ScrollToTop from '../../presentational/ScrollToTop/ScrollToTop';
import LoadedPageContainer from './LoadedPageContainer';
import {triggerEdapPageView} from '../../../utils/edap';

import {HomeRouteContext} from 'utils/context';
import {parse} from 'query-string';

export const query = gql`
    query brandCategories($sitename: String, $preview: Boolean) {
        translationsCollection(where: {site: $sitename}, preview: $preview) {
            items {
                home
                headerButton
                categories
                articles
                exploreArticles
                browseByCategory
                browseBySubcategory
                previous
                next
                expand
                collapse
                openMenu
                closeMenu
                copyLink
            }
        }
        homeCollection(where: {site: $sitename}, preview: $preview) {
            items {
                sys {
                    id
                }
                socialShare
            }
        }
        allCategories: categoryCollection(
            where: {site: $sitename}
            preview: $preview
        ) {
            items {
                name
                slug
                parentId
                path
                sys {
                    id
                }
            }
        }
    }
`;

class PageContainer extends Component {
    state = {
        params: this.props.match.params,
        systemData:
            typeof window !== 'undefined' && window.systemData
                ? window.systemData
                : this.props.systemData,
    };

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            triggerEdapPageView();
        }
    }

    render() {
        const {systemData} = this.state;
        const {location} = this.props;
        const preview = parse(location.search).preview === 'true';
        const variables = {sitename: systemData.siteName, preview};

        return (
            <Fragment>
                <ScrollToTop {...this.props.location} />
                <HomeRouteContext.Provider value={this.props.homeRoute}>
                    <Query {...{query, variables}}>
                        {(response) => {
                            return (
                                <LoadedPageContainer
                                    {...{
                                        response,
                                        ...this.props,
                                        ...this.state,
                                        preview,
                                    }}
                                />
                            );
                        }}
                    </Query>
                </HomeRouteContext.Provider>
                <SiteFooter data={this.props.footerData} />
            </Fragment>
        );
    }
}

export default PageContainer;
